import { Link } from "react-router-dom";
import { articleList } from "@/mocks/articles";

export default function ArticleSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3 md:mb-4">
            Artykuły o Kakobuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Poznaj poradniki, recenzje, przewodniki i analizy dotyczące Kakobuy Spreadsheet – wszystko w jednym miejscu
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleList.slice(0, 9).map((article) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 hover:scale-[1.02] cursor-pointer flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img
                  src={article.heroImage}
                  alt={article.title}
                  className="w-full h-44 md:h-48 object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">
                    {article.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readingTime}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1 line-clamp-3">
                  {article.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}